import type { ComponentProps } from 'react';
import { cn } from './ui/utils';

export function SurfaceCard({ className, ...props }: ComponentProps<'div'>) {
  return (
    <div
      className={cn(
        'rounded-lg border border-border bg-card shadow-sm',
        className,
      )}
      {...props}
    />
  );
}

export default SurfaceCard;
